<template>
  <v-app id="roster_logs">
    <!-- roster names -->
    <v-container id="rname_container">
      <v-row no-gutters>
        <v-col cols="12" md="12" class="rname_expansion">
          <!-- Expansion Panels -->
          <v-expansion-panels>
            <!-- names Expansion Panel -->
            <v-expansion-panel class="mb-3">
              <v-expansion-panel-header
                class="rname_expansion white--text rounded-b-0"
              >
                NAMES
                <template v-slot:actions>
                  <v-icon color="white" x-large> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content color="cmpbkinside">
                <!-- toolbar -->
                <v-toolbar flat class="roster-toolbar">
                  <v-toolbar-title>Roster Names</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-btn
                    dark
                    class="mb-2 greenbtn black--text"
                    @click="openDialog_rname"
                    >New Name</v-btn
                  >
                </v-toolbar>
                <!-- <hr /> -->

                <!-- NAMES LIST -->
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-list class="list-rname">
                        <hr />
                        <v-list-item
                          class="single-name d-flex flex-row justify-space-between"
                          v-for="(item_rname, index) in items_rname"
                          :key="index"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              item_rname.name
                            }}</v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action class="d-flex flex-row">
                            <v-icon
                              class="mr-3"
                              small
                              @click="editItem_rname(index)"
                              >$edit</v-icon
                            >
                            <v-icon small @click="deleteItem_rname(index)"
                              >$del</v-icon
                            >
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- END names Expansion Panel -->
          </v-expansion-panels>
          <!-- end Roster Expansion Panels -->
        </v-col>
      </v-row>

      <!-- New Name Dialog -->

      <v-dialog v-model="openDialog_rname_show" max-width="500px">
        <v-card class="secondary">
          <v-card-title>
            <span class="headline">{{ formTitle_rname }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem_rname.name"
                    label="Name"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="rnameCloseDialog"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" text @click="saveItem_rname"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END New Name Dialog -->
    </v-container>
  </v-app>
</template>

<style lang="scss" scoped>
/* 0 media q */
@media (min-width: 0px) {
  #roster_logs {
    width: 96%;
    margin: 0 auto;
    margin-top: 67px;
  }

  #roster_logs:deep.theme--light.v-application {
    background: none;
  }

  #roster_logs:deep .v-application--wrap {
    /* min-height: 100vh !important; */
    min-height: auto;
  }

  /* roster logs names */
  .rname_expansion {
    height: 48px;
    width: 100%;
    margin: 0 auto;
    background-color: #708e92;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }

  .rname_expansion p {
    font-size: 0.9375rem;
  }

  .roster-toolbar {
    height: 30px !important;
  }

  .single-name {
    border-bottom: 2px solid #0000001f;
  }

  .list-rname hr {
    margin-top: 20px;
    border-color: #0000001f;
  }

  /* End roster names */
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";

export default {
  name: "simpleList_wAdd",
  components: {},
  mixins: [bus_common],
  data() {
    return {
      openDialog_rname_show: false,

      items_rname: [
        { name: "Autry" },
        { name: "Baehr" },
        { name: "Butler" },
        { name: "Chang" },
        { name: "Christensen, B" },
        { name: "Clifford" },
        { name: "Donigan" },
        { name: "Dougherty" },
        { name: "Duralde" },
        { name: "Espinoza, A" },
        { name: "Hakin" },
        { name: "Hanna" },
        { name: "Hendrix" },
        { name: "Hogan" },
        { name: "Hoyt" },
        { name: "Kent" },
        { name: "Kerfoot" },
        { name: "Lancaster" },
        { name: "Lopey" },
        { name: "Mathiowetz" },
        { name: "Meseberg" },
        { name: "Perham, J" },
        { name: "Robles" },
        { name: "Rousseau" },
        { name: "Schaur" },
        { name: "Schmidt" },
        { name: "Smith" },
        { name: "Sotelo" },
        { name: "Struffert" },
        { name: "Tom" },
        { name: "Tone" },
        { name: "Waasdorp" },
        { name: "Williams" },
        { name: "Ziese" },
      ],

      editedIndex_rname: -1,
      editedItem_rname: {
        name: "",
      },
      defaultItem_rname: {
        name: "",
      },
    };
  },
  computed: {
    formTitle_rname() {
      return this.editedIndex_rname === -1
        ? "New Roster Name"
        : "Edit Roster Name";
    },
  },

  /* METHODS */
  methods: {
    /* Roster names */
    openDialog_rname() {
      this.openDialog_rname_show = true;
      this.editedItem_rname = this.mno(this.defaultItem_rname);
    },
    editItem_rname(index) {
      this.editedIndex_rname = index;
      this.editedItem_rname = this.mno(this.items_rname[index]);
      this.openDialog_rname_show = true;
    },
    deleteItem_rname(index) {
      this.items_rname.splice(index, 1);
    },
    rnameCloseDialog() {
      this.openDialog_rname_show = false;
      this.$nextTick(() => {
        this.editedItem_rname = this.mno(this.defaultItem_rname);
        this.editedIndex_rname = -1;
      });
    },
    saveItem_rname() {
      console.log(this.editedItem_rname.name);
      if (this.editedIndex_rname > -1) {
        this.items_rname[this.editedIndex_rname] = this.mno(
          this.editedItem_rname
        );
      } else {
        this.items_rname.push(this.editedItem_rname);
      }
      this.rnameCloseDialog();
    },
  },
};
</script>
